import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchNonAdfs(data:any) {
  const response = await instance.get(`/verify/company/list/non-adfs/?type=${data}`);
  return response.data;
}
export async function fetchAllCompany(data:any) {
  let companyType=(data.type)?data.type:""
  const response = await instance.get(`/verify/company/list?type=${companyType}&id=${data.id}`);
  return response.data;
}
export async function fetchInsertCompany(data:any) {
  const response = await instance.post(`/verify/company`, data);
  return response.data;
}
export async function fetchUpdateCompany(data:any) {
  const response = await instance.put(`/verify/company`, data);
  return response.data;
}
export async function fetchDeleteCompany(data:any) {
  const response = await instance.delete(`/verify/company/${data}`, );
  return response.data;
}

